import React from 'react';
import { Monitor } from 'lucide-react';
import BusinessReplyCard from './UI/BusinessReplyCard';

const themes = [
    { id: 'paradise', name: 'Paradise', color: '#e6e2d3', label: 'ORIGINAL' },
    { id: 'lagoon', name: 'Lagoon', color: '#b8e2f2', label: 'BLUE WATER' },
    { id: 'sunset', name: 'Sunset', color: '#f5d0b5', label: 'WARM SAND' },
    { id: 'jungle', name: 'Jungle', color: '#dbe7c9', label: 'PALM LEAF' },
];

const Settings = ({ currentTheme, onThemeChange, onOpenFeedback }) => {
    return (
        <div className="h-full flex flex-col bg-[#e8e6df] font-sans select-none p-6 overflow-y-auto">
            {/* Header */}
            <div className="flex items-center justify-between mb-8 border-b border-[#bdbaa8] pb-4">
                <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-[#333] rounded flex items-center justify-center text-white shadow-lg">
                        <Monitor size={16} />
                    </div>
                    <div>
                        <h2 className="text-sm font-bold uppercase tracking-widest text-[#333]">System Config</h2>
                        <p className="text-[9px] text-[#666] uppercase tracking-wider">Display Settings</p>
                    </div>
                </div>
                <div className="flex space-x-1">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#333]"></div>
                    <div className="w-1.5 h-1.5 rounded-full bg-[#bdbaa8]"></div>
                    <div className="w-1.5 h-1.5 rounded-full bg-[#bdbaa8]"></div>
                </div>
            </div>

            {/* Theme Selection */}
            <div className="flex-1">
                <label className="block text-[9px] font-bold uppercase tracking-widest text-[#666] mb-4">
                    Environment Theme
                </label>

                <div className="grid grid-cols-1 gap-3">
                    {themes.map((theme) => (
                        <button
                            key={theme.id}
                            onClick={() => onThemeChange(theme.id)}
                            className={`group relative flex items-center p-3 rounded-lg border transition-all duration-200 ${currentTheme === theme.id
                                ? 'bg-[#dcdad3] border-[#999] shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]'
                                : 'bg-[#f4f1ea] border-transparent shadow-[0_2px_5px_rgba(0,0,0,0.05)] hover:translate-y-[-1px] hover:shadow-md'
                                }`}
                        >
                            {/* Mini Window Preview */}
                            <div
                                className={`w-10 h-8 rounded border shadow-sm mr-4 relative overflow-hidden flex-shrink-0 transition-all ${currentTheme === theme.id ? 'ring-2 ring-[#ff4400] ring-offset-1' : 'border-black/10'}`}
                                style={{ backgroundColor: theme.color }}
                            >
                                {/* Window chrome: traffic light dots */}
                                <div className="absolute top-1 left-1 flex items-center gap-0.5">
                                    <div className="w-1 h-1 rounded-full bg-[#ff5f57]"></div>
                                    <div className="w-1 h-1 rounded-full bg-[#febc2e]"></div>
                                    <div className="w-1 h-1 rounded-full bg-[#28c840]"></div>
                                </div>
                                {/* Title bar separator */}
                                <div className="absolute top-3.5 left-0 right-0 h-px bg-black/10"></div>
                                {/* Content dots */}
                                <div className="absolute bottom-1.5 left-1 right-1 flex items-center gap-1">
                                    <div className="h-0.5 flex-1 rounded-full bg-black/15"></div>
                                    <div className="h-0.5 w-2 rounded-full bg-black/10"></div>
                                </div>
                            </div>

                            {/* Label */}
                            <div className="flex-1 text-left">
                                <div className="text-xs font-bold text-[#333] uppercase tracking-wide">{theme.name}</div>
                                <div className="text-[8px] text-[#888] uppercase tracking-widest">{theme.label}</div>
                            </div>

                            {/* Active Indicator */}
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center transition-colors ${currentTheme === theme.id
                                ? 'bg-[#ff4400] border-[#cc3700] shadow-[0_0_5px_rgba(255,68,0,0.4)]'
                                : 'bg-[#dcdad3] border-[#bdbaa8]'
                                }`}>
                                {currentTheme === theme.id && <div className="w-1.5 h-1.5 bg-white rounded-full"></div>}
                            </div>
                        </button>
                    ))}
                </div>
            </div>


            {/* Member Requests (Club/Executive) */}
            {
                onOpenFeedback && (
                    <div className="mt-8">
                        <label className="block text-[9px] font-bold uppercase tracking-widest text-[#666] mb-4">
                            Member Communications
                        </label>
                        <BusinessReplyCard onClick={onOpenFeedback} />
                    </div>
                )
            }

            {/* Footer / Status */}
            <div className="mt-auto pt-6 border-t border-[#bdbaa8]">
                <div className="flex items-center justify-between text-[9px] text-[#888] uppercase tracking-widest font-mono">
                    <span>OS Version 2.4.0</span>
                    <span className="flex items-center">
                        <div className="w-1.5 h-1.5 rounded-full bg-green-500 mr-2 animate-pulse"></div>
                        System Online
                    </span>
                </div>
            </div>
        </div >
    );
};

export default Settings;
